import { handleWelcome, COURSE_TYPE } from '@/api/grt/videoQA';
import ToastUtils from '../ToastUtils';

export const handleGetWelcome = async (courseId: string, courseType = COURSE_TYPE.DEMOND) => {
    let res = await handleWelcome({ course_id: courseId, course_type: courseType });
    if (res && res.success) {
        return res?.data || [];
    } else {
        ToastUtils.showAbnormalToast(res.msg || '操作失败');
        return '';
    }
};

